<template>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-event="openEditEvent">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
            </div>
            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
  
                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- VIEW EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="Operation"
        accept-text= "View"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="clickViewEvent(labelLocal.toLowerCase())"
        :active.sync="activePromptEditEvent">

        <div class="my-4">
            <big class="date-label"><b>Title</b></big>
            {{ title }}
        </div>
        <div class="my-4">
            <big class="date-label"><b>Date</b></big>
            {{ startDate }}
        </div>
        <div v-if="labelLocal === 'Reception'" class="my-4">
            <big class="date-label"><b>Supplier</b></big>
            {{ client }}
        </div>
        <div v-if="labelLocal === 'Transport' && client" class="my-4">
            <big class="date-label"><b>Transporter</b></big>
            {{ client }}
        </div>
        <div v-if="labelLocal === 'Transport' && client2" class="my-4">
            <big class="date-label"><b>Client</b></big>
            {{ client2 }}
        </div>
        <div class="my-4" v-if="labelLocal !== 'Transport'">
            <big class="date-label"><b>Product Category</b></big>
            {{ category_name }}
        </div>
        <div class="my-4" v-if="labelLocal !== 'Transport'">
            <big class="date-label"><b>Product</b></big>
            {{ product_name }}
        </div>
        <div class="my-4" v-if="labelLocal !== 'Transport'">
            <big class="date-label"><b>Volume</b></big>
            {{ volume }} m3
        </div>
        <div class="my-4" v-if="volume2 && labelLocal === 'Transport'">
            <big class="date-label"><b>Quotation</b></big>
            {{ ref_quote }}
        </div>
        <div class="my-4" v-if="volume2 && labelLocal === 'Transport'">
            <big class="date-label"><b>Volume Transported</b></big>
            {{ volume2 }} m3
        </div>
        <div class="my-4" v-if="price && labelLocal === 'Transport' &&  this.isadmin">
            <big class="date-label"><b>Transport cost</b></big>
            {{ price/volume }} €
        </div>
        <div class="my-4" v-if="price2 && labelLocal === 'Transport' &&  this.isadmin">
            <big class="date-label"><b>Transport value</b></big>
            {{ price2 }} €
        </div>
        <div class="my-4" v-if="price && labelLocal === 'Reception' &&  this.isadmin">
            <big class="date-label"><b>Cost</b></big>
            {{ price }} €
        </div>
        <div class="my-4" v-if="price && labelLocal === 'Purchase Order' &&  this.isadmin">
            <big class="date-label"><b>Cost</b></big>
            {{ price }} €
        </div>
    </vs-prompt>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require('vue-simple-calendar/static/css/default.css')

import Datepicker from 'vuejs-datepicker'
import { en } from 'vuejs-datepicker/src/locale'

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker
  },
  data () {
    return {
      isadmin:false,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      title: '',
      client: '',
      product_name: '',
      client2: '',
      category_name: '',
      ref_quote:'',
      volume: '',
      volume2: '',
      startDate: '',
      labelLocal: 'none',
      price: '',
      price2: '',

      langEn: en,

      url: '',
      calendarView: 'week',

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: 'Week',
          val: 'week'
        },
        {
          label: 'Month',
          val: 'month'
        }
      ]
    }
  },
  computed: {
    simpleCalendarEvents () {
      return this.$store.state.calendar.events
    },
    disabledDatesTo () {
      return { to: new Date(this.startDate) }
    },
    disabledDatesFrom () {
      return { from: new Date(this.endDate) }
    },
    calendarLabels () {
      return this.$store.state.calendar.eventLabels
    },
    labelColor () {
      return (label) => {
        if      (label === 'invoice') return 'success'
        else if (label === 'reception')     return 'danger'
        else if (label === 'transformation') return 'warning'
        else if (label === 'inventory') return 'warning'
        else if (label === 'purchase') return 'warning'
        else return 'primary'
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
    },
    openEditEvent (event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.id = e.id
      this.product_name = e.product_name
      this.title = e.label+" #"+e.id
      this.startDate = e.startDate
      this.labelLocal = e.label
      this.category_name = e.category_name
      this.client = e.client 
      this.client2 = e.client2
      this.volume = e.volume
      this.ref_quote = e.ref_quote
      this.client = e.client
      this.volume2 = e.volume2
      this.price2 = e.price2
      this.price = e.price
      this.activePromptEditEvent = true
    },
    clickViewEvent (type) {
      if (type.includes("purchase")) this.$router.push({ path: "/purchase/" + this.id });
      else this.$router.push({ path: "/"+type+"/" + this.id });
    },
    removeEvent () {
     //close popup
    }
  },
  created () {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.isadmin = true
    } 
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch('calendar/fetchEvents')
    this.$store.dispatch('calendar/fetchEventLabels')
  },
  beforeDestroy () {
    this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
